import { z } from "zod";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { UserRoleEntity } from "~/entities/user-role/@x/auth";
import type { WithoutMethods } from "~/shared/utility-types";
import { createSelectors } from "~/shared/zustand";

const zAuthenticationStatus = z.enum(["UNCERTAIN", "UNAUTHENTICATED", "AUTHENTICATED"]);
const AuthenticationStatus = zAuthenticationStatus.Enum;
type AuthenticationStatus = z.infer<typeof zAuthenticationStatus>;

type State = {
  login: (roles: UserRoleEntity.Schema[]) => void;
  logout: () => void;
  reset: () => void;
} & {
  status: AuthenticationStatus;
  roles: UserRoleEntity.Schema[];
};

const initialState: WithoutMethods<State> = {
  status: AuthenticationStatus.UNCERTAIN,
  roles: [],
};

const STORE_NAME = "AuthStore";

const useAuthStore = createSelectors(
  create<State>()(
    devtools(
      (set) =>
        ({
          ...initialState,
          login: (roles) =>
            set({
              status: AuthenticationStatus.AUTHENTICATED,
              roles,
            }),
          logout: () =>
            set({
              ...initialState,
              status: AuthenticationStatus.UNAUTHENTICATED,
            }),
          reset: () => set(initialState),
        }) satisfies State,
      {
        store: STORE_NAME,
      },
    ),
  ),
);

export { AuthenticationStatus, useAuthStore, zAuthenticationStatus };
